import {
  gql
} from "@apollo/client";
import { CHARGER_ASSET_DETAILS_FRAGMENT } from "gql/fragments";

export const CHARGERS = gql`
  ${CHARGER_ASSET_DETAILS_FRAGMENT}
  query Chargers($chargers_n: Int, $after: String, $chargers_where: ChargerSearchFilter) {
    chargers(n: $chargers_n, after: $after, where: $chargers_where) @connection(key: "paginatedChargers") {
      edges {
        cursor
        node {
          salesforce_details: salesforce_details {
            ...ChargerAssetDetails
          }
          assetDetails: salesforce_details {
            ...ChargerAssetDetails
          }
          details: salesforce_details {
            ...ChargerAssetDetails
          }
          serial
          vpn_status {
            connections {
              allowed_ips
            }
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      totalCount
    }
  }
`;

export const UPDATE_FIRMWARE = gql`
  mutation Update_firmware($payload: InputUpdateFirmwareRequestPayload, $serial: String) {
    charger_ocpp_mutation {
      update_firmware(payload: $payload, serial: $serial) {
        payload {
          status
        }
      }
    }
  }
`;
